"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = void 0;
const request_1 = require("../utils/request");
const request = ({ method, endpoint, serviceUrl, body = undefined, headers = {}, options = { encode: false, rawRequest: false, rawResponse: false, withStatusCode: false }, }) => {
    const { rawResponse, withStatusCode, encode, rawRequest, ...prepareRequestOptions } = options;
    const { url, init } = (0, request_1.prepareRequest)({
        method,
        endpoint,
        serviceUrl,
        body,
        headers,
        options: {
            ...prepareRequestOptions,
            rawRequest: !!rawRequest,
            encode: !!encode,
        },
    });
    return fetch(url, init).then((response) => (0, request_1.formatResponse)({ response, withStatusCode, rawResponse }));
};
exports.request = request;
//# sourceMappingURL=request.js.map